import HisAutocompleteSuggestions from '@/components/HisAutocompleteSuggestions/index.vue';
import {
  pageSizes,
  pickerOptions,
  ageSections,
} from '@/config/constant';
import pageSize from '@/mixins/memoryPageSize';
import setUrl from '@/mixins/setUrl';

export default {
  name: 'patient-list',
  components: { HisAutocompleteSuggestions },
  mixins: [pageSize, setUrl],
  data() {
    return {
      ageSection: null, // 年龄段
      ageSections,
      total: 0,
      pageSizes,
      pickerOptions,
      time: [],
      input: 0,
      form: {
        resource: '',
      },
      query: {
        /* 标签 */
        tags: [],
        /* 患者名称或电话 */
        nameOrPhone: '',
        /* 就诊开始时间 */
        clinicStartTime: '',
        /* 就诊结束时间 */
        clinicEndTime: '',
        /* 年龄开始时间 */
        ageStart: '',
        /* 年龄结束时间 */
        ageEnd: '',
        /* 当前页 */
        currentPage: 1,
        /* 每页数据条数 */
        pageSize: 20,
        /* 性别 */
        gender: -1,
      },
      rowList: [{
        name: '编号',
        value: 'id',
        minWidth: '',
        isSortable: false,
        disabled: false,
        checked: true,
      },
      {
        name: '会员名称',
        value: 'name',
        minWidth: '100',
        isSortable: false,
        disabled: false,
        checked: true,
      },
      {
        name: '性别',
        value: 'gender',
        minWidth: '',
        isSortable: false,
        disabled: false,
        checked: true,
      },
      {
        name: '年龄',
        value: 'age',
        minWidth: '',
        isSortable: false,
        disabled: false,
        checked: true,
      },
      {
        name: '诊断',
        value: 'inquiry',
        minWidth: '',
        isSortable: false,
        disabled: false,
        checked: true,
      },
      {
        name: '标签',
        value: 'tags',
        minWidth: '',
        isSortable: false,
        disabled: false,
        checked: true,
      },
      {
        name: '操作',
        value: 'op',
        minWidth: '',
        isSortable: false,
        disabled: false,
        checked: true,
      },
      ],
      tableData: [],
      tagsId: null, // 选中标签id
      tagByHos: [], // 诊所标签
      upTags: [], // 待选标签
      tags: [], // 标签列表
    };
  },
  methods: {
    // 跳转会员详情
    goDetail(pid) {
      this.$router.push({ path: '/outPatient/memberDetail', query: { id: pid } });
    },
    // 跳转添加会员
    addMember() {
      this.$router.push({ path: '/outPatient/newmember', query: { type: 1 } });
    },
    // 添加标签
    addTag(array) {
      const that = this;
      that.upTags = Array.from(that.tagByHos);
      // 清空标签选中状态
      that.upTags = that.upTags.map(item => ({
        ...item,
        isChoose: false,
      }));
      console.log(that.upTags);
      array.forEach((ele) => {
        if (ele.tagType === 1) {
          that.upTags.forEach((el, index) => {
            if (ele.tagId === el.tagId) {
              that.upTags[index].isChoose = true;
            }
          });
        }
      });
    },
    // 修改标签
    updatePatientTag(tag, patientIds, type, tags) {
      console.log(111);
      this.$api.member.updatePatientTag({
        patientId: patientIds,
        tagId: tag.tagId,
        status: type,
      }).then((res) => {
        console.log(res);
        if (type === 0) {
          tags.forEach((el, index) => {
            if (tag.tagId === el.tagId) {
              tags.splice(index, 1);
            }
          });
          this.upTags.forEach((el, index) => {
            if (tag.tagId === el.tagId && tag.tagType === 1) {
              this.upTags[index].isChoose = false;
            }
          });
        } else {
          this.upTags.forEach((el, index) => {
            if (tag.tagId === el.tagId && tag.tagType === 1) {
              this.upTags[index].isChoose = true;
            }
          });
          tags.push(tag);
        }
      });
    },
    // 获取诊所标签
    getTag() {
      this.$api.member.tag().then((res) => {
        console.log(res);
        this.tags = res.hosPitalTag;
        this.tags.forEach((item) => {
          if (item.tagType === 1) {
            this.tagByHos.push(item);
          }
        });
      });
    },
    getPatients(type) {
      if (type === 1) this.query.currentPage = 1;
      if (this.time) {
        [this.query.clinicStartTime, this.query.clinicEndTime] = this.time;
      } else {
        this.query.clinicStartTime = '';
        this.query.clinicEndTime = '';
      }
      this.queryChangeHandle();
      this.$api.outPatient.patients(this.query).then((res) => {
        console.log(res);
        this.tableData = res.patientList;
        this.total = res.totalSize;
      });
    },
    handleSizeChange() {
      this.getPatients(1);
    },
    handleCurrentChange(value) {
      console.log(value);
      this.query.currentPage = value;
      this.getPatients();
    },
    querySearch(queryString, cb) {
      let list = [];
      this.query.nameOrPhone = queryString;
      this.$api.outPatient.listclinicPatientByNameOrPhone({
        patientConditions: queryString,
      }).then((res) => {
        list = res.patinetList.map(item => ({
          patientName: item.patientName,
          phoneNo: item.phoneNo,
          gender: item.gender,
          year: item.year,
          month: item.month,
          day: item.day,
        }));
        cb(list);
      });
    },
    // 选中患者
    handleSelect(e) {
      this.query.nameOrPhone = e.patientName;
      this.getPatients(1);
    },
    // 新建处方
    addPrescription(pid) {
      this.$router.push({ path: '/outPatient/outMedicalRecord', query: { id: pid } });
    },
    // 下拉选取标签的时候确定数组内部数据格式
    changeTag(item) {
      let index = 0;
      const isChoose = this.query.tags.some((elem, i) => {
        if (elem === item.tagId) index = i;
        return elem === item.tagId;
      });
      if (isChoose) {
        this.query.tags.splice(index, 1);
      } else {
        this.query.tags.push(item.tagId);
      }
    },
    // 标签下拉关闭时候触发
    getPatientsBySelected() {
      if (this.selectedStatus) {
        this.getPatients(1);
      }
      this.selectedStatus = !this.selectedStatus; // 第一次打开空白页的时候不触发查询事件，状态为true,关闭之后selectedStatus置为FALSE
    },
    // 年龄转换
    setAge() {
      switch (this.ageSection) {
        case 1:
          this.query.ageStart = '';
          this.query.ageEnd = 14;
          break;
        case 2:
          this.query.ageStart = 14;
          this.query.ageEnd = 28;
          break;
        case 3:
          this.query.ageStart = 28;
          this.query.ageEnd = 40;
          break;
        case 4:
          this.query.ageStart = 40;
          this.query.ageEnd = 55;
          break;
        case 5:
          this.query.ageStart = 55;
          this.query.ageEnd = '';
          break;
        default:
          this.query.ageStart = '';
          this.query.ageEnd = '';
          break;
      }
      this.getPatients(1);
    },
    // 筛选触发事件
    queryChangeHandle() {
      this.setPath({
        time: this.time,
        nameOrPhone: this.query.nameOrPhone,
        gender: this.query.gender,
        ageSection: this.ageSection,
        currentPage: this.query.currentPage,
      });
    },
    // 通过url初始化筛选项
    initQuery() {
      const queryUrl = this.getPath();
      this.time = queryUrl.time ? queryUrl.time : [];
      this.query.nameOrPhone = queryUrl.nameOrPhone ? queryUrl.nameOrPhone : '';
      this.query.gender = queryUrl.gender ? Number(queryUrl.gender) : -1;
      this.query.currentPage = queryUrl.currentPage ? Number(queryUrl.currentPage) : 1;
      this.ageSection = queryUrl.ageSection ? Number(queryUrl.ageSection) : '';
      this.setAge();
      this.getPatients();
    },
  },
  mounted() {
    this.initQuery();
    this.getTag();
  },
};
